<template>
  <div class="container">
    <section>
      <div class="layout">
        <div class="child">
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h2>{{questionTitle}}</h2>
              </div>
            </div>
          </div>
          <div>
            <form class="pure-form pure-form-stacked" @submit.prevent="handleSubmit" novalidate>
              <fieldset>

                <div v-if="areMultipleQuestionsAllowed">
                  <div class="pure-g">
                    <div class="pure-u-1-2">
                      <div class="pdng-1">
                        <button type="button" class="pure-button bigmi-wide-button bigmi-red-2-button"
                                @click="on1QuestionModeClick">
                          <span>1 Question</span>
                        </button>
                      </div>
                    </div>
                    <div class="pure-u-1-2">
                      <div class="pdng-1">
                        <button type="button" class="pure-button bigmi-wide-button bigmi-red-2-button"
                                @click="on2QuestionModeClick">
                          <span>2 Questions</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pure-g">
                  <div class="pure-u-1">
                    <div>
                      <h3>
                        Please type the question that you would like your respondents to answer.
                      </h3>
                    </div>
                  </div>
                </div>
                <div v-for="ratingQuestion in formModel.questions">
                  <div>
                    <div class="pure-g">
                      <div class="pure-u-1">
                        <textarea v-model="ratingQuestion.ratingQuestion"
                                  :class="ratingQuestion.getClassObj().ratingQuestion" rows="5"
                                  :ref="textareaRefName"
                                  :placeholder="ratingQuestionPlaceholder"></textarea>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="pure-g highest-scale">
                        <div class="pure-u-4-5">
                          <div class="select-label">
                            <div class="hint-section">
                              <span>The lowest value is 1, choose the highest scale value:</span>
                            </div>
                          </div>
                        </div>
                        <div class="pure-u-1-5">
                          <select v-model="formModel.scale">
                            <option :value="option" v-for="option in scaleOptions">{{option}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="form-row" style="text-align: center">
                      <div style="padding: 5px 0 15px 0">
                        <span>
                          You must fill in #1 and #{{formModel.scale}}.  You have an option of defining the numbers in between but it’s not required.
                        </span>
                      </div>
                    </div>
                    <div v-for="(value, idx) in allPossibleValues" :key="idx" class="form-row">
                      <div class="pure-g">
                        <div class="pure-u-3-5">
                          <div class="hint-section">
                            <span>What does {{value}} mean on the scale?</span>
                          </div>
                        </div>
                        <div class="pure-u-2-5">
                          <input v-if="value === 1" type="text" v-model="ratingQuestion.lowEnd"
                                 :class="ratingQuestion.getClassObj().lowEnd"
                                 :placeholder="lowEndPlaceholder">
                          <input v-else-if="value === formModel.scale" type="text" v-model="ratingQuestion.highEnd"
                                 :class="ratingQuestion.getClassObj().highEnd"
                                 :placeholder="highEndPlaceholder">
                          <input v-else type="text" v-model="ratingQuestion.intermediateValues[value]">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <button type="submit" class="hidden-submit"></button>
              </fieldset>
              <BigStudyNavigation @touched="onTouched"></BigStudyNavigation>
            </form>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {
    GET_NEXT_STUDY_STEP_ROUTE,
    GET_IN_PROGRESS_STUDY_RATING_SCALE_NUMBER_OPTIONS,
    SET_IN_PROGRESS_STUDY_RATING_SCALE_OBJ,
    GET_IN_PROGRESS_STUDY_NUMBER_OF_QUESTIONS,
    UPDATE_STUDY,
    CSS_CLASS_NAME_INVALID,
  } from '../../services/constants'


  const ratingQuestionFactory = () => {
    return {
      ratingQuestion: '',
      lowEnd: '',
      highEnd: '',
      intermediate: ''
    }
  }

  const formModelFactory = () => {
    return {
      questions: [],
      scale: -1,
    }
  }


  export default {
    name: 'RatingScale',
    data() {
      return {
        formModel: formModelFactory(),
        submitTouched: false
      }
    },
    computed: {
      ...mapGetters([
        GET_NEXT_STUDY_STEP_ROUTE,
        GET_IN_PROGRESS_STUDY_RATING_SCALE_NUMBER_OPTIONS,
        GET_IN_PROGRESS_STUDY_NUMBER_OF_QUESTIONS
      ]),
      questionTitle() {
        return 'RATING SCALE'
      },
      isScaleValid() {
        return this.formModel.scale > -1
      },
      areQuestionsValid() {
        return this.formModel.questions.map(question => {
          return {
            ratingQuestionIsValid: question.ratingQuestion.trim().length > 0,
            lowEndIsValid: question.lowEnd.trim().length > 0,
            highEndIsValid: question.highEnd.trim().length > 0
          }
        })
      },
      showQuestionsValidationUI() {
        return this.areQuestionsValid.map(question => {
          return {
            showRatingQuestionValidationUI: !question.ratingQuestionIsValid && this.submitTouched,
            showLowEndValidationUI: !question.lowEndIsValid && this.submitTouched,
            showHighEndValidationUI: !question.highEndIsValid && this.submitTouched,
          }
        })
      },
      questionsValidationClassObjs() {
        return this.showQuestionsValidationUI.map(question => {
          return {
            ratingQuestion: {
              [CSS_CLASS_NAME_INVALID]: question.showRatingQuestionValidationUI,
            },
            lowEnd: {
              [CSS_CLASS_NAME_INVALID]: question.showLowEndValidationUI,
            },
            highEnd: {
              [CSS_CLASS_NAME_INVALID]: question.showHighEndValidationUI,
            },
          }
        })
      },
      isFormModelValid() {
        return this.isScaleValid && this.areQuestionsValid.every(question => {
          return question.ratingQuestionIsValid && question.lowEndIsValid && question.highEndIsValid
        })
      },
      textareaRefName() {
        return 'textareaRef'
      },
      placeholder() {
        return ''
      },
      scaleOptions() {
        return this[GET_IN_PROGRESS_STUDY_RATING_SCALE_NUMBER_OPTIONS]
      },
      ratingQuestionsFromStore() {
        return this.$store.state.dataModule.inProgressStudy.ratingQuestions
      },
      scaleFromStore() {
        let maxScale = this.$store.state.dataModule.inProgressStudy.maxRating
        return maxScale === -1 ? 9 : maxScale
      },
      areMultipleQuestionsAllowed() {
        return this[GET_IN_PROGRESS_STUDY_NUMBER_OF_QUESTIONS] === 6
      },
      ratingQuestionPlaceholder(){
        return 'How likely are you to buy this product?'
      },
      lowEndPlaceholder(){
        return 'Unlikely'
      },
      highEndPlaceholder(){
        return 'Likely'
      },
      allPossibleValues () {
        return this.formModel.scale > 0 ? [...Array(this.formModel.scale).keys()].map(num => num += 1) : []
      },
      formModelForSubmit () {
        let modifiedQuestions = this.formModel.questions.map((question) => {
          let intermediate = Object.keys(question.intermediateValues)
            .filter(key => Number(key) !== 1 && Number(key) !== Number(this.formModel.scale))
            .map((key) => `${key}=${question.intermediateValues[key]}`)
            .join(';')
          return {
            ratingQuestion: question.ratingQuestion,
            lowEnd: question.lowEnd,
            highEnd: question.highEnd,
            intermediate: intermediate
          }
        })
        return Object.assign({}, this.formModel, {questions: modifiedQuestions})
      }
    },
    methods: {
      handleSubmit() {
        if (this.isFormModelValid) {
          this.$store.commit(SET_IN_PROGRESS_STUDY_RATING_SCALE_OBJ, this.formModelForSubmit)
          this.$store.dispatch(UPDATE_STUDY).then(() => {
            this.$router.push(this[GET_NEXT_STUDY_STEP_ROUTE])
          })
        }
      },
      resetFormModel() {
        this.formModel = formModelFactory()
        let obj = null
        if (this.ratingQuestionsFromStore.length > 0) {
          for (let i = 0; i < this.ratingQuestionsFromStore.length; i++) {
            const obj = this.ratingQuestionsFromStore[i]
            obj.getClassObj = () => {
              return this.questionsValidationClassObjs[i]
            }
            obj.intermediateValues = this.allPossibleValues.reduce((acc,curr)=> (acc[curr]='', acc), {})
            const previousValues = this.ratingQuestionsFromStore[i].intermediate ? this.ratingQuestionsFromStore[i].intermediate.split(";") : []
            previousValues.forEach(keyValuePair => {
              const keyValueArray = keyValuePair.split("=")
              const key = keyValueArray[0]
              const value = keyValueArray[1]
              obj.intermediateValues[key] = value
            });
            this.formModel.questions.push(Object.assign({}, obj))
          }
        } else {
          const obj = ratingQuestionFactory()
          obj.intermediateValues = this.allPossibleValues.reduce((acc,curr)=> (acc[curr]='', acc), {})
          obj.getClassObj = () => {
            return this.questionsValidationClassObjs[0]
          }
          this.formModel.questions.push(obj)
        }
        this.formModel.scale = this.scaleFromStore
      },
      updateFormModel(){
        let objs = []
        for (let i = 0; i < this.formModel.questions.length; i++) {
          const question = this.formModel.questions[i]
          const freshIntermediateValues = this.allPossibleValues.reduce((acc,curr)=> (acc[curr]='', acc), {})
          const newIntermediateValues = Object.assign({}, freshIntermediateValues, question.intermediateValues)
          question.intermediateValues = Object.keys(newIntermediateValues)
            .filter(key => key <= this.formModel.scale)
            .reduce((obj, key) => {
              obj[key] = newIntermediateValues[key];
              return obj;
            }, {});
          objs.push(question)
        }
        this.formModel.questions = objs
      },
      focusFirstQuestion() {
        //$nextTick only needed for Chrome, firefox works without it
        this.$nextTick(() => {
          this.$refs[this.textareaRefName][0].focus()
        })
      },
      on1QuestionModeClick() {
        this.formModel.questions.splice(1)
      },
      on2QuestionModeClick() {
        if (this.formModel.questions.length === 1) {
          const obj = ratingQuestionFactory()
          obj.getClassObj = () => {
            return this.questionsValidationClassObjs[i]
          }
          this.formModel.questions.push(obj)
        }
      },
      onTouched() {
        this.submitTouched = true
      },
    },
    watch: {
      'formModel.scale': function() {
        this.updateFormModel()
      }
    },
    created() {
      this.resetFormModel()
    },
    mounted() {
      this.focusFirstQuestion()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .container {
    height: 100%;
  }

  section {
    height: 100%;
  }

  .layout {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
  }

  .child {
    width: 100%;
    max-width: 500px;
    margin: 1em;
  }

  span {
    font-size: 1.17em;
  }

  h2 {
    text-align: center;
    color: $red-2;
  }

  h3 {
    color: $cyan-blue-3;
  }

  .pure-form input[type="text"], .pure-form textarea, select {
    box-shadow: none;
    width: 100%;
    color: $cyan-blue-3;
    border-color: $cyan-blue-3;

    &:focus {
      border-color: $cyan-blue-1;
    }
    &:placeholder-shown {
      color: $gray-3;
    }
    &:-ms-input-placeholder {
      color: $gray-3;
    }

    &.invalid {
      border-color: $red-2;
    }
  }

  .form-row {
    color: $cyan-blue-3;
    font-size: 14px;

    .highest-scale{
      padding: 10px 0 ;
    }

    .hint-section {
      padding: 10px;
    }
  }

  .select-label {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .question-title {
    font-size: 0.83em;
    font-weight: bold;
    color: $cyan-blue-3;
  }

  ::placeholder {
    color: $gray-3;
    opacity: 1;
  }

</style>
